import { onlineApplicationsDefaultConfiguration } from "@/src/constants/applicationOnlineConsts";
import { admissionDatabaseDefaultConfiguration } from "@/src/constants/AdmissionOffice/admissionOfficeDatabaseConsts";
import { normalizeVisibleTOPColumns, tasksDefaultConfiguration } from "@/src/constants/tasksTableColumns";
import { officeAccountingDefaultConfiguration } from "@/src/constants/officeAccountingTableConfig";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { sideBarMenuAllOptions } from "@/src/constants/sidebar";
import { getUserConfigFromStorage } from "@/src/utils/userConfigStorage";
import { IUserOptionsConfig } from "@/src/types/userOptions";

const userConfig = getUserConfigFromStorage();

const initialState: IUserOptionsConfig = {
  AOPConfig: {
    AOPTable: userConfig?.AOPConfig?.AOPTable || onlineApplicationsDefaultConfiguration,
    AOPFixed: userConfig?.AOPConfig?.AOPFixed ?? null,
  },
  TOPConfig: {
    TOPTable: normalizeVisibleTOPColumns(userConfig?.TOPConfig?.TOPTable ?? tasksDefaultConfiguration),
    TOPFixed: userConfig?.TOPConfig?.TOPFixed ?? null,
  },
  AODPConfig: {
    AODPTable: userConfig?.AODPConfig?.AODPTable || admissionDatabaseDefaultConfiguration,
    AODPFixed: userConfig?.AODPConfig?.AODPFixed ?? null,
  },
  OAPConfig: {
    OAPTable: userConfig?.OAPConfig?.OAPTable || officeAccountingDefaultConfiguration,
    OAPFixed: userConfig?.OAPConfig?.OAPFixed ?? null,
  },
  SideBarConfig: {
    list: userConfig?.SideBarConfig?.list || sideBarMenuAllOptions,
  },
};

const userOptionsSlice = createSlice({
  name: "userOptions",
  initialState,
  reducers: {
    setActualUserConfig(state, action: PayloadAction<Partial<IUserOptionsConfig>>) {
      if (action.payload.AOPConfig) {
        state.AOPConfig = {
          ...state.AOPConfig,
          ...action.payload.AOPConfig,
        };
      }
      if (action.payload.AODPConfig) {
        state.AODPConfig = {
          ...state.AODPConfig,
          ...action.payload.AODPConfig,
        };
      }
      if (action.payload.TOPConfig) {
        state.TOPConfig = {
          ...state.TOPConfig,
          ...action.payload.TOPConfig,
          ...(action.payload.TOPConfig.TOPTable
            ? { TOPTable: normalizeVisibleTOPColumns(action.payload.TOPConfig.TOPTable) }
            : {}),
        };
      }
      if (action.payload.OAPConfig) {
        state.OAPConfig = {
          ...state.OAPConfig,
          ...action.payload.OAPConfig,
        };
      }
      if (action.payload.SideBarConfig) {
        state.SideBarConfig = {
          list: action.payload.SideBarConfig.list || state.SideBarConfig.list,
        };
      }
    },
  },
});

export const { setActualUserConfig } = userOptionsSlice.actions;

export default userOptionsSlice.reducer;
